import request from '@/utils/request'
import qs from 'qs'


const proxyUrl = process.env.Communityapi;
const Community = process.env.Community;
const Jingjiribao = process.env.Jingjiribao;
const Estoreapi = process.env.Estoreapi;

// 注册-----------------------------------------
// 注册接口
// export const doReg_resigin = (data) => {
//   return request({
//     method: 'POST',
//     url: Jingjiribao + '/user/doReg',
//     data: qs.stringify(data),
//   })
// }

export const doReg_resigin = (data) => {
  return request({
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    method: 'POST',
    url: proxyUrl + '/user/doRegNew',
    data: data,
  })
};

// 私钥
export const me_key = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/getKeyPair',
    data: qs.stringify(data),
  })
}
// 登录-----------------------------------------
// 发送验证码
export const post_phone_code = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/verifycode/verifycode',
    data: qs.stringify(data),

  })
}
// 是否登陆
export const Info = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/getInfo',
    data: qs.stringify(data),

  })
}

// 登录后的信息
export const doLogin = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/doLogin',
    data: qs.stringify(data),
  })
}

// 消息
export const ismsg = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/community/message/ismsg',
    data: qs.stringify(data),
  })
}

// 忘记密码---------------------------------------

export const forgotpwd = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/forgotpwd',
    data: qs.stringify(data),
  })
}

//验证手机号
export const testing_phone = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/doCheckPhone',
    data: qs.stringify(data),
  })
}
//发送手机验证码
export const sendMessage = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/sendMessage',
    data: qs.stringify(data)

  })
}
// 退出账号
export const logout = (data) => {
  return request({
    method: 'POST',
    url: Jingjiribao + '/user/logout',
    data: qs.stringify(data)

  })
}
// 登录获取初始化参数接口
export const getInitParams = (data) => {
  return request({
    method: 'get',
    url: Estoreapi + '/inint/getInitParams',
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/utils/api/login.js